// Port of api/fuel/app/classes/filter/search/users/filters/query/member.php
export default {
	name: 'user.member',
	priority: 1,
	require: function(config, filter) { return true },
	run: function(config, filter, data, query) {
		query.where('u.user_id', 'in', data.users)
	}
}
